// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2j1uw","buttons":"SendReceipts_buttons__jBAc_","email":"SendReceipts_email__1toIL","bookApptTitle":"SendReceipts_bookApptTitle__26N48"};